<template>
  <div class="trip-details">
    <DetailedTrip :alert="sweetAlert"></DetailedTrip>
  </div>
</template>

<script>
import DetailedTrip from '@/components/tripDetails/DetailedTrip.vue';

export default {
  name: 'TripDetails',
  data() {
    return {
      sweetAlert: this.$swal
    };
  },
  components: {
    DetailedTrip
  }
};
</script>

<style scoped></style>
